import {EditorView} from "prosemirror-view";
import {EditorState, TextSelection, Transaction} from "prosemirror-state";

import {replaceTextRangeWithNode, replaceSelectionParagraphWithNode} from "./utils";


export interface ParamsFromTriggerMenu {
    nodePos: number;
    textInput: string;
}
export interface ParamsFromPlusMenu {
    getPos: () => number;
}

export type InsertMentionTriggerAdditionalParams = ParamsFromTriggerMenu | ParamsFromPlusMenu;

export const insertMentionTrigger = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, additionalParams?: InsertMentionTriggerAdditionalParams) => {
    const mentionTriggerText = '@';
    const mentionTrigger = state.schema.text(mentionTriggerText);

    let tr;
    if (additionalParams) {
        if (pramsIsFromPlusMenu(additionalParams)) {
            tr = state.tr.insertText(mentionTriggerText, additionalParams.getPos() + 1);
        } else {
            /* textInput doesn't contain the first letter so we need + 1 */
            tr = replaceTextRangeWithNode(state, additionalParams.nodePos, additionalParams.nodePos + additionalParams.textInput.length + 1,  mentionTrigger);
        }
    } else {
        tr = replaceSelectionParagraphWithNode(state, mentionTrigger);
    }

    if (tr !== state.tr) {
        if (dispatch && view) {
            dispatch(tr);
            view.focus();
        }
        return true;
    }

    return false;
}

function pramsIsFromPlusMenu(params: InsertMentionTriggerAdditionalParams): params is ParamsFromPlusMenu {
    return 'getPos' in params;
}